import React from "react";
import { Target, Briefcase, Wrench } from "lucide-react";
import { SectionTitle, Bullet } from "./primitives";

const ExperienceItem = ({ job }) => (
  <div className="keep-together relative pl-4 border-l-2 border-[var(--line)]">
    <span className="absolute -left-[6px] top-1 h-[9px] w-[9px] rounded-full bg-[var(--ink)] ring-2 ring-white" />
    <div className="flex flex-wrap items-baseline justify-between gap-x-3">
      <h3 className="text-[15px] font-bold text-[var(--ink-dark)]">{job.company}</h3>
      <span className="text-[12px] font-medium text-[var(--ink)] whitespace-nowrap">{job.period}</span>
    </div>
    <p className="text-[12.5px] italic text-[var(--muted)]">{job.meta}</p>
    <p className="text-[13px] font-semibold text-[var(--text)] mb-1.5">{job.role}</p>
    <ul>
      {job.points.map((point) => <Bullet key={point}>{point}</Bullet>)}
    </ul>
    {job.link && (
      <a
        href={job.link.href}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-1 mt-1 ml-4 text-[12.5px] font-semibold text-[var(--ink)] hover:text-[var(--ink-dark)] hover:underline transition-colors"
      >
        {job.link.label}
      </a>
    )}
  </div>
);

const RightColumn = ({ data }) => (
  <main className="space-y-8">
    {/* CEO Alignment */}
    <section>
      <SectionTitle icon={Target} sub={data.ceoAlignment.subtitle}>CEO Alignment</SectionTitle>
      <div className="space-y-2.5">
        {data.ceoAlignment.items.map((it) => (
          <div key={it.head} className="relative pl-4">
            <span className="absolute left-0 top-[8px] h-[5px] w-[5px] rounded-full bg-[var(--ink)]" />
            <span className="text-[13.5px] font-semibold text-[var(--ink-dark)]">{it.head} — </span>
            <span className="text-[13.5px] leading-relaxed text-[var(--text)]">{it.body}</span>
          </div>
        ))}
      </div>
    </section>

    {/* Experience */}
    <section className="pdf-break-before pdf-profexp">
      <SectionTitle icon={Briefcase}>Professional & Executive Experience</SectionTitle>
      <div className="space-y-5">
        {data.experience.map((job) => <ExperienceItem key={job.company} job={job} />)}
      </div>
    </section>

    {/* Early career */}
    <section>
      <SectionTitle icon={Wrench}>Early Career — Trade & Operations</SectionTitle>
      <div className="flex flex-wrap items-baseline justify-between gap-x-3">
        <h3 className="text-[15px] font-bold text-[var(--ink-dark)]">{data.earlyCareer.company}</h3>
        <span className="text-[12px] font-medium text-[var(--ink)] whitespace-nowrap">{data.earlyCareer.period}</span>
      </div>
      <p className="text-[12.5px] italic text-[var(--muted)] mb-1.5">{data.earlyCareer.role}</p>
      <ul>
        {data.earlyCareer.points.map((point) => <Bullet key={point}>{point}</Bullet>)}
      </ul>
    </section>
  </main>
);

export default RightColumn;
